/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'facebook': {
    width: 436.036,
    height: 436.041,
    viewBox: '0 0 436.036 436.041',
    data: '<defs><clipPath id="svgicon_facebook_a" clipPathUnits="userSpaceOnUse"><path pid="0" d="M0 0h512v512H0z"/></clipPath></defs><g clip-path="url(#svgicon_facebook_a)" transform="matrix(1.33333 0 0 -1.33333 -122.667 558.667)"><path pid="1" d="M374.96 419H136.067C111.73 419 92 399.27 92 374.934V136.039c0-24.339 19.73-44.066 44.066-44.066h117.82l.204 116.859h-30.363a7.16 7.16 0 0 0-7.161 7.137l-.148 37.672a7.166 7.166 0 0 0 7.164 7.191h30.309v36.399c0 42.238 25.797 65.238 63.476 65.238h30.922a7.166 7.166 0 0 0 7.164-7.164v-31.762a7.163 7.163 0 0 0-7.16-7.164l-18.977-.011c-20.492 0-24.46-9.735-24.46-24.028v-31.511h45.027c4.293 0 7.62-3.747 7.113-8.004l-4.465-37.672a7.162 7.162 0 0 0-7.113-6.321h-40.36l-.202-116.863h70.105c24.336 0 44.066 19.731 44.066 44.067v238.898c0 24.336-19.73 44.066-44.066 44.066" _fill="#1c1c1b"/></g>'
  }
})
